export const CLICK_POST_TITLE = 'postTitle/CLICK';

export const clickPostTitle = ({ post, titleType }) => ({
  type: CLICK_POST_TITLE,
  payload: { post, titleType },
});
